import { createSelector } from 'reselect';

import { getSelectedGroupId } from 'modules/groups/selectors';

import { getSelectedDealerId, getDealerDefaultLanguage } from 'selectors/dealerSelectors';

const MIN_PAGINATION_SIZE = 10;

/**
 * @param {any} state
 * @returns {import('modules/dealers/reducer/ui/dashboard').DashboardState}
 */
const getState = state => state.dealers.ui.dashboard;

export const getPage = createSelector(getState, state => state.page);

const getSort = createSelector(getState, state => state.sort);

export const getIds = createSelector(getState, state => state.ids);

export const getParams = createSelector(
  getPage,
  getSort,
  getDealerDefaultLanguage,
  getSelectedDealerId,
  getSelectedGroupId,
  ({ size }, sort, language, dealerId, groupId) => ({
    sort,
    language,
    ids: [...(dealerId ? [dealerId] : [])],
    groupIds: [...(groupId ? [groupId] : [])],
    size: Math.max(MIN_PAGINATION_SIZE, size),
  })
);

export const isReady = createSelector(getState, state => state.isReady);
